import validate from 'validate.js';

validate.validators.presence.options = { message: '^To pole nie może być puste'};
validate.validators.email.options = { message: '^To pole musi zawierać poprawny adres e-mail'};
